import { v4 as uuidv4 } from 'uuid';

let listeners = [];

// system payload: {uuid: string, path: string, type: 'send'|'reply', data: any}
// eslint-disable-next-line no-underscore-dangle
const resolveMessage = payload => {
  const { uuid, path, type, data } = payload;
  console.log('[JsBridgeMessage][pushToUI]:', path, [payload]);
  listeners.forEach(listener => {
    if (listener.path === path && (!listener.uuid || listener.uuid === uuid)) {
      try {
        listener.cb(data, uuid);
      } catch (ex) {
        console.error(ex);
      }
    }
  });
};

export const removeMessageListener = id => {
  listeners = listeners.filter(l => l.id !== id);
};

export const isAvailableConnection = function() {
  return window.hasOwnProperty('pushToNative');
};

export const connect = () => {
  return new Promise((resolve, reject) => {
    const waitInitIntrv = setInterval(() => {
      console.log('Wait connection availability');
      if (isAvailableConnection()) {
        clearInterval(waitInitIntrv);
        window.pushToUI = resolveMessage;
        resolve();
      }
    }, 100);
  });
};

export const disconnect = () => {
  listeners.length = 0;
};

const sysAddMessageListener = ({ path, uuid }, cb) => {
  const item = { path, cb, id: uuidv4() };

  if (uuid) {
    item.uuid = uuid;
  }

  listeners.push(item);

  return item.id;
};

export const addMessageListener = (path, cb) => sysAddMessageListener({ path }, cb);

export function sendMessagePromise(path, data, timeout = 3000, replyUUID = null) {
  const uuid = replyUUID || uuidv4();
  const payload = { path, data, uuid, type: 'reply' };

  return new Promise((resolve, reject) => {
    if (window.pushToNative) {
      const subs = { subsId: undefined, timerId: undefined };
      // eslint-disable-next-line no-unused-vars
      subs.subsId = sysAddMessageListener({ path, uuid }, (response, requestUUID) => {
        console.log(`sendMessagePromise: got response for ${requestUUID}: `, response);
        clearTimeout(subs.timerId);
        removeMessageListener(subs.subsId);
        resolve(response);
      });
      console.log(`sendMessagePromise: registered subsId: ${subs.subsId}`);
      subs.timerId = setTimeout(
        subsId => {
          if (subsId) {
            removeMessageListener(subsId);
          }
          reject(new Error('timeout'));
          console.error(`sendMessagePromise: timeout for ${subsId}`);
        },
        timeout,
        subs.subsId,
      );
      console.log(`sendMessagePromise: registered timeout timer with id: ${subs.timerId}`);
      try {
        console.log(`sendMessagePromise: sending `, payload);
        window.pushToNative(payload);
      } catch (ex) {
        clearTimeout(subs.timerId);
        removeMessageListener(subs.subsId);
        reject(ex);
        console.error('sendMessagePromise: error ', ex);
      }
      // return uuid;
    } else {
      console.error('`pushToNative` method not defined!');
      reject();
    }
  });
}

export const sendMessage = (path, data, clb, replyUUID = null) => {
  const uuid = replyUUID || uuidv4();
  const payload = { path, data, uuid, type: replyUUID ? 'reply' : 'send' };
  let subscrId = null;
  if (clb) {
    subscrId = sysAddMessageListener({ path, uuid }, (response, requestUUID) => {
      removeMessageListener(subscrId);
      clb(response, requestUUID);
    });
  }
  try {
    console.log('[JsBridgeMessage][pushToNative]:', path, [payload]);
    window.pushToNative(payload);
  } catch (ex) {
    if (subscrId) {
      removeMessageListener(subscrId);
    }
    throw ex;
  }
  return uuid;
};
